import { Article } from '../../store/article';
import { User } from '../../store/auth';
import { Comment } from '../../store/comment';
import { FileData } from '../../store/types';
import {
  DefaultFetchError,
  FetchCreate,
  FetchGet,
  PagingDataResponse,
  PagingParams,
  useFetchCreate,
  useFetchGet,
} from '../fetch';
import { Category, SubCategory } from './createaccount';

export interface PostsData {
  data: Post[];
  total: number;
}

export interface Business {
  id: string;
  name: string;
  description: string;
  email: string;
  zipCode: string;
  type: string;
  website: string;
  address: string;
  phone: string;
  status: string;
  file: FileData;
  createdAt: string;
  updatedAt: string;
  users: User[];
  categories: SubCategory[];
  subCategories: SubCategory[];
}

export interface Reaction {
  id: string;
  status: boolean;
  user: User & {
    role?: string;
    status?: string;
    businesses: Business[];
    settings: {
      isEmailVerified: boolean;
      isPhoneVerified: boolean;
    };
    country: {
      id: number;
      name: string;
      iso3: string;
    };
    category: Category;
    subCategory: SubCategory;
  };
  createdAt: string;
}

export interface Post {
  id: string;
  text: string;
  status: string;
  entity: string;
  numberOfLikes: number;
  numberOfDislikes: number;
  numberOfComments: number;
  numberOfCommentsTotal: number;
  files: FileData[];
  user: User;
  subPostCount: number;
  business: Business;
  category: Category;
  subCategory: SubCategory;
  article: Article;
  createdAt: string;
  updatedAt: string;
  comments: Comment[];
}

interface PostDataParams extends PagingParams {
  orderByColumn?: 'createdAt';
}

export interface PostResponse extends Post {
  key: string;
}

export const usePostGet = <DD = PostsData>(
  decorateData?: (data: PagingDataResponse<Post>) => DD,
): FetchGet<
  PagingDataResponse<Post>,
  PostDataParams,
  DefaultFetchError,
  DD
> => useFetchGet(
    'posts',
    {
      autoStart: true, startStateLoading: false, decorateData,
    },
  );

export const usePostGetAll = () => usePostGet<PostsData>(
  ({ data, meta }: PagingDataResponse<Post>): PostsData => ({
    data: data.map((item: Post): PostResponse => ({
      key: item.id,
      ...item,
    })),
    total: meta.itemCount,
  }),
);
export const usePostsCreate = (): FetchCreate<Partial<Post>, DefaultFetchError> => (
  useFetchCreate('posts', { autoStart: false, startStateLoading: false })
);
